import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {numberParce} from '../../../server/util';
import NotificationSystem from 'react-notification-system';
import {_addNotification,_addNotificationError,numberOnly} from '../../../server/util';
import {get,postWithHeaders,putWithHeadersResponse} from "../../../server/actions";
import {getLoginDistrictInfo, dial_code, mobileNoLength} from "../../../server/utilDistrict";
let userInfo=getLoginDistrictInfo();
class UserRecord extends Component {
    constructor(props){
        super(props);
        this.state={
            id:0,
            data:{},
            mobileLength:mobileNoLength(),
            user:{
                firstName: '',
                lastName: '',
                username: '',
                mobileNo: '',
                isPrimaryUser:true,
                isUnsubscribeGenNotif:false,
                "isActive": true,
                "isPrimaryUser": false,
                "isVerified": false,
            }
        }
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }
    componentWillMount=()=>{     
        this.props.changeShowHideSchoolFitler(false);   
        const _id=numberParce(this.context.router.route.match.params.id);
        const data=(this.context.router.route.location.state||{}).data||{}
        if(_id>0){
            this.setState({id:_id, data:data, 
                user:{...data.record, mobileNo: (data.record.mobileNo||'').substr(-this.state.mobileLength)}});
        }else{
            this.setState({id:_id, data:data,
            user:{...this.state.user,  role: !data.isDistrict?"ROLE_DISTRICT": "ROLE_ADMIN" }});
        }
    }
    handleChange=(e)=>{
        const _user=this.state.user;
        _user[e.target.name]=e.target.value;
        this.setState({user:_user})
    }
    handleCheckBoxChange=(e)=>{
        const _user=this.state.user;
        _user[e.target.name]=e.target.checked?true:false;
        this.setState({user:_user});
    }
    handleSubmit=(event)=> {
        event.preventDefault();
        document.getElementById("submit").disabled = true;
        const {data,user}=this.state;
        this.setState({loading: true});
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        if(this.state.user.mobileNo.length!==0 && this.state.user.mobileNo.length<this.state.mobileLength){
            _addNotificationError('Please provide valid mobile no.', this);
            document.getElementById("submit").disabled = false;
            return false;
        }
        if(!data.isDistrict){
            if(user.schoolId<=0){
                _addNotificationError('Please select school.', this);
                document.getElementById("submit").disabled = false;
                return false;
            }
        let formData = {
            loggedUser: userInfo.username,
            isPaymentEnabled:null,
            schoolUsers:[{...user,mobileNo:user.mobileNo.length>0?dial_code()+user.mobileNo:'', }]
            }
        postWithHeaders('/mealSchoolUpdate?mealSchoolId=' + user.schoolId + '&access_token=', JSON.stringify(formData), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        }).then(data => {
            _addNotification('Successfully added/updated user data.', this);
            this.setState({loading: false,modalManageUsersIsOpen: false});
            this.context.router.history.push(`/district/users`)
        })
        .catch(
            (error) => {
                document.getElementById("submit").disabled = false;
                this.setState({loading: false});
                _addNotificationError('Could not added/updated user data.', this);
                console.log('Onboard User response', error)
            }
        );
        }else{
            let formData = {
                loggedUser: userInfo.username,
                isPaymentEnabled:null,
                districtUsers:[{...user, mobileNo:user.mobileNo.length>0?dial_code()+user.mobileNo:''}
                   ]
                }
                putWithHeadersResponse(`/${userInfo.districtId}/district?access_token=`, JSON.stringify(formData), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                _addNotification('Successfully added/updated user data.', this);
                this.setState({loading: false,modalManageUsersIsOpen: false});
                this.context.router.history.push(`/district/users`)
            })
            .catch(
                (error) => {
                    document.getElementById("submit").disabled = false;
                    this.setState({loading: false});
                    _addNotificationError('Could not added/updated user data.', this);
                    console.log('Onboard User response', error)
                }
            );
        }
       
    }
    render() {
        userInfo=getLoginDistrictInfo();
        const {id,user,data}=this.state;
        return (
            <div>
                <section>
                <NotificationSystem ref="notificationSystem"/>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>{`${id>0?'Edit User':'Add User'}`}</span>
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-3 col-md-6">
                            <form onSubmit={this.handleSubmit}>
                                <div>
                                    <div className="form-group">
                                                    <label className="control-label" htmlFor="county">First
                                                        Name*</label>
                                                    <input type="text" name="firstName"
                                                           className="form-control border-color-1 rounded" id="fname"
                                                           placeholder="First Name" value={user.firstName}
                                                           onChange={(e)=>{this.handleChange(e)}} required/>
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="district">Last
                                                        Name*</label>
                                                    <input type="text" name="lastName"
                                                           className="form-control border-color-1 rounded" id="lname"
                                                           placeholder="Last Name" value={user.lastName}
                                                           onChange={(e)=>{this.handleChange(e)}} required/>
                                                </div>
                                                { 
                                                !data.isDistrict?
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="district">School*</label>
                                                    <select name="schoolId" className="form-control border-color-1 rounded" placeholder="" value={user.schoolId}
                                                           onChange={(e)=>{this.handleChange(e)}} required>
                                                               <option></option>
                                                               {
                                                                   (userInfo.schools||[]).map(school=>{
                                                                       return <option value={school.schoolId}>{school.schoolName}</option>
                                                                   })
                                                               }

                                                    </select>
                                                </div>
                                                :null
                                                }
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="county">Phone*</label>
                                                    <input type="text" 
                                                    name="mobileNo"
                                                                className="form-control"
                                                                value={user.mobileNo}
                                                                id="mobileNum"
                                                                placeholder={'Mobile Number'}
                                                                onChange={(e)=>{this.handleChange(e)}}
                                                                maxLength={10}
                                                                onKeyPress={numberOnly} 
                                                                required />
                                                    
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="school">Email ID*</label>
                                                    <input type="email" name='username'
                                                           pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                           className="form-control border-color-1 rounded"
                                                           placeholder="Email ID" value={user.username}
                                                           onChange={(e)=>{this.handleChange(e)}} disabled={id>0 ? true:false} required/>
                                                    <span id={user.username} className="validateMessage"></span>
                                                </div>
                                                <div className="checkbox col-sm-12" style={{marginTop:'10px',padding:'0'}}>
                                                <label style={{fontWeight: '700'}}>
                                                <input type="checkbox" class="radio" checked={!!user.isPrimaryUser}
                                                onChange={(e)=>{this.handleCheckBoxChange(e)}} name="isPrimaryUser" />Primary User </label>
                                                </div>
                                                <div className="checkbox col-sm-12" style={{marginTop:'10px',padding:'0'}}>
                                                <label style={{fontWeight: '700'}}>
                                                <input type="checkbox" class="radio" checked={user.isUnsubscribeGenNotif} 
                                                onChange={(e)=>{this.handleCheckBoxChange(e)}} name="isUnsubscribeGenNotif" />Unsubscribe For General Notifications </label>
                                                </div>
                                                <div className="form-group col-sm-12">
                                                    <hr style={{color: 'lightgray !important'}}/>
                                                </div>
                                            </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <a href="javascript:void(0);" className="pull-left">
                                            <button className="btn btn-primary btn-sm" type="button" 
                                            onClick={(e)=>{
                                                this.context.router.history.push(`/district/users`)
                                            }}
                                                    style={{margin: 0, fontSize: 14}}>Back
                                            </button>
                                        </a>

                                        <button className="btn btn-success btn-sm pull-right" id="submit"
                                                type="submit" style={{margin: 0, fontSize: 14}}>Finish
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
UserRecord.contextTypes = {
    router: PropTypes.object.isRequired
}

export default UserRecord;


// WEBPACK FOOTER //
// ./src/components/District/Users/userRecord.jsx